import Head from 'next/head'
import sanitizeHtml from 'sanitize-html'
import { replaceAll, truncate } from '../lib/strings'

const ListMeta = ({ list }) => {
  const listDescription = () => {
    let description = null
    if (list.description) description = truncate(list.description)
    else if (list.body) {
      description = truncate(
        replaceAll(sanitizeHtml(list.body, { allowedTags: [] }), '&nbsp;', ' ')
      )
    }
    return description
  }

  function listImage() {
    if (list.hero_image) {
      return list.hero_image
    } else if (list.ListItems[0]) {
      return list.ListItems[0].image
    } else {
      return null
    }
  }

  function listTitle() {
    if (list.User) {
      return `${list.User.username} - ${list.title}`
    } else if (list.name && list.name.length > 0) {
      return `${list.name} - ${list.title}`
    } else {
      return list.title
    }
  }

  function twitterTitle() {
    const title = listTitle()

    if (title.length > 70) {
      return title.substring(0, 69) + '...'
    } else {
      return title
    }
  }

  return (
    <Head>
      <title>{listTitle()}</title>
      {listDescription() && (
        <meta name="description" content={listDescription()} />
      )}
      <meta property="og:image" content={listImage()} />
      <meta
        property="og:url"
        content={`https://buymusic.club/list/${list.slug}`}
      />
      {list.User && list.User.twitter && (
        <meta name="twitter:creator" content={list.User.twitter} />
      )}
      <meta property="twitter:title" content={twitterTitle()} />
      <meta name="twitter:card" content="summary_large_image" />
    </Head>
  )
}

export default ListMeta
